import 'npm/jquery.easing'



// WEBPACK FOOTER //
// ./src/initializers/jquery-easing.js